<ngb-toast
  *ngFor="let toast of toastsService.toasts"
  [class]="toast.classname"
  [autohide]="true"
  [delay]="toast.delay || 5000"
  (hidden)="toastsService.remove(toast)"
>
  <span class="toast-icon material-icons-round" [ngClass]="toast.iconcolor">{{ toast.iconname }}</span>
  <span class="truncate-text" [innerHtml]="toast.textOrTpl"></span>
</ngb-toast>
